import { getFiles } from '@/API/repositories/file';
import { FILE_TYPES } from '@/common/constants/fileTypes';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useRef, useState } from 'react';

const useInstructionsPopUp = ({ handleSubmit }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const isLoading = hasUnfilledRequest(getFiles);

	const [fileOptions, setFileOptions] = useState([]);
	const [selectedFileNames, setSelectedFileNames] = useState([]);
	const dateRef = useRef();

	const fetchFiles = async () => {
		const response = await makeRequest(() => getFiles(FILE_TYPES.CC));

		if (!response?.data) {
			return addMessage("Couldn't load call center positions", 'error');
		}

		setFileOptions(
			response.data.map(({ filename, info, _id }) => ({
				label: `${info ?? ''} ${filename}`.trim(),
				value: _id,
			})),
		);
	};

	const onSubmit = (e) => {
		e.preventDefault();

		const date = dateRef.current.value;
		handleSubmit({
			contractDate: date,
			fileIds: selectedFileNames.map(
				(selectedFileName) => selectedFileName.value,
			),
		});
	};

	useEffect(() => {
		fetchFiles();
	}, []);

	return {
		isLoading,
		onSubmit,
		fileOptions,
		setSelectedFileNames,
		selectedFileNames,
		dateRef,
	};
};

export default useInstructionsPopUp;
